import { render, staticRenderFns } from "./aiGlobalSwitch.vue?vue&type=template&id=76a9d55a&scoped=true"
import script from "./aiGlobalSwitch.vue?vue&type=script&lang=js"
export * from "./aiGlobalSwitch.vue?vue&type=script&lang=js"
import style0 from "./aiGlobalSwitch.vue?vue&type=style&index=0&id=76a9d55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9d55a",
  null
  
)

export default component.exports